/**
 * Build the WhatsApp share URL for a TalesLore story.
 * The URL that recipients open is the PERSISTENT story URL, so the recipient
 * always sees the free preview + payment gate + create-your-own CTA.
 */
export function buildWhatsAppShareUrl({ childName, storyTitle, storyUrl }) {
  const msg = `✨ ${childName} just got their own mythology bedtime story!
"${storyTitle}"
Read it here: ${storyUrl}
Create one for your child at taleslore.com 🌙`;
  return `https://wa.me/?text=${encodeURIComponent(msg)}`;
}

// Build the persistent story URL (used both for share link and for internal navigation).
export function buildStoryUrl(storyId, { origin } = {}) {
  const base = (origin || (typeof window !== 'undefined' ? window.location.origin : 'https://www.taleslore.com')).replace(/\/$/, '');
  return `${base}/story/${storyId}`;
}
